import { RefObject, useLayoutEffect, useState } from "react";

type Size = { width: number; height: number };

export const useResizeObserver = <T extends HTMLElement>(
  targetRef: RefObject<T>
): Size => {
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = targetRef.current;
    if (!element) {
      return;
    }

    setSize(element.getBoundingClientRect());

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, [targetRef]);

  return size;
};
